import memoize from 'lodash/memoize';
import pick from 'lodash/pick';
import isObject from 'lodash/isObject';

import { createSelector } from 'reselect';

export const createCachedSelector = (...args: any[]) => {
  const hashResolver = args[args.length - 1];
  const combiner = args[args.length - 2];
  const selectors = args.slice(0, args.length - 2);
  
  const cachedCombiner = memoize(combiner, hashResolver);

  // FIX: Pass the array of selectors directly instead of spreading.
  // Reselect accepts createSelector([s1, s2], combiner)
  return createSelector(selectors, cachedCombiner);
};

export const hashByKeys = (keys: string[]) => (data: any[]) => {
  const hashKey = JSON.stringify(data.map((value) => (isObject(value) ? pick(value, keys) : value)));

  return hashKey;
};

export const hashByStatus = hashByKeys(['id', 'status']);

export { createSelector } from 'reselect';